/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `theft` - Furt
 * * `frigo` - Marfă frigorifică
 */
export enum RisksEnum {
  THEFT = 'theft',
  FRIGO = 'frigo',
}
